// Convert an incoming deep-link URL into an in-app route path.
// Handles the custom scheme (es.qcap.app://app/billing?x=1) and, once Associated
// Domains / App Links are configured server-side, https universal links
// (https://qcap.es/app/billing?x=1). Returns a router path or null.
export function parseDeepLinkPath(url) {
    try {
        const u = new URL(url);
        if (u.protocol.startsWith("http")) {
            return (u.pathname || "/") + u.search;
        }
        // Custom scheme: the first segment lands in u.host, the rest in u.pathname.
        const path = `/${u.host || ""}${u.pathname || ""}`.replace(/\/{2,}/g, "/");
        return (path === "/" ? "/" : path.replace(/\/$/, "")) + u.search;
    } catch {
        return null;
    }
}

export function isOAuthCallbackPath(path) {
    return /^\/app\/connections\/[a-z0-9_-]+\/callback(\?|$)/i.test(path || "");
}
